module.exports = new __parcel__URL__("litepaper_2_tokenomics_text.14f07eba.png").toString();